import { Typography } from '@mui/material'
import type { TypographyProps } from '@mui/material'
import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { FC, ReactNode } from 'react'

export interface VariableTextProps extends TypographyProps {
    variableText: string | React.ReactElement | React.ReactElement[] | undefined
    emptyState?: ReactNode
}

// A component for displayed text that does not always have a value, and needs text when empty.
export const VariableText: FC<VariableTextProps> = ({ variableText, emptyState = <C1EmptyIndicator />, ...props }) => {
    if (variableText) return <Typography {...props}>{variableText}</Typography>

    return <>
        { typeof emptyState === 'string'
            ? <Typography {...props} variant="unconfigured">{emptyState}</Typography>
            : <>{emptyState}</> }
    </>
}
